import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LayoutDashboard, Film, Upload, BarChart3, DollarSign, Wallet, Scale, Settings } from 'lucide-react';
import { useApi } from '../lib/api';
import { useApp } from '../context/AppContext';

export const STUDIO_NAV = [
  { to: '/studio', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/studio/content', label: 'Content', icon: Film },
  { to: '/studio/upload', label: 'Upload', icon: Upload },
  { to: '/studio/analytics', label: 'Analytics', icon: BarChart3 },
  { to: '/studio/revenue', label: 'Revenue', icon: DollarSign },
  { to: '/studio/payments', label: 'Payments', icon: Wallet },
  { to: '/studio/rights', label: 'Rights', icon: Scale },
  { to: '/studio/settings', label: 'Settings', icon: Settings },
];

export const money = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/** Loads /studio/overview for the signed-in creator. Redirects guests to sign-in. */
export function useStudio() {
  const navigate = useNavigate();
  const { user, authLoading, isCreator } = useApp();
  const q = useApi('/studio/overview', { enabled: !!user && isCreator, deps: [user?.id] });
  React.useEffect(() => { if (!authLoading && !user) navigate('/signin'); }, [authLoading, user, navigate]);
  return { ...q, user, authLoading, isCreator, content: q.data?.content || [], stats: q.data?.stats || {}, revenue: q.data?.revenue || {}, creator: q.data?.creator };
}

export function Gate({ authLoading, user, isCreator, children }) {
  if (authLoading) return <div className="text-[#C7C4CB] text-sm">Loading...</div>;
  if (!user) return null;
  if (!isCreator) return <div className="surface p-8 text-center"><h3 className="font-semibold">Creator access required</h3><p className="text-[13px] text-[#C7C4CB] mt-1">Apply to become a Clax creator from your account settings.</p></div>;
  return children;
}
